<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3878_622)">
      <mask id="mask0_3878_622" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <path d="M24 0H0V24H24V0Z" fill="white"/>
      </mask>
      <g mask="url(#mask0_3878_622)">
        <path d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68627 15.3137 6 12 6C8.68627 6 6 8.68627 6 12C6 15.3137 8.68627 18 12 18Z" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3.24902 4.93051C4.16027 3.80251 5.81252 3.62701 6.94052 4.53826C8.06852 5.44951 8.24402 7.10176 7.33277 8.22975" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M20.751 19.0695C19.8397 20.1975 18.1875 20.373 17.0595 19.4618C15.9315 18.5505 15.756 16.8983 16.6672 15.7703" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M19.0695 3.24896C20.1975 4.16021 20.373 5.81246 19.4618 6.94046C18.5505 8.06848 16.8983 8.24398 15.7703 7.33271" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4.93045 20.751C3.80245 19.8397 3.62695 18.1875 4.5382 17.0595C5.44945 15.9315 7.1017 15.756 8.2297 16.6672" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3878_622">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>

</template>

<script>
import iconMixin from './iconMixin.js'

export default {
  mixins: [iconMixin]
}
</script>
